module.exports = __webpack_public_path__ + "static/media/ProviderReferral.a0ba73e8.txt";